import { useEffect, useState } from 'react';
import { getProteinTypes } from 'business/services/IngredientService';

const useGetProteinTypeList = (showProteinTypeModal, refetchCounter) => {
  const [proteinTypeList, setProteinTypeList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const proteinTypesData = await getProteinTypes();
      setProteinTypeList(proteinTypesData);
    };
    if (showProteinTypeModal) {
      fetchData();
    }
  }, [showProteinTypeModal, refetchCounter]);

  return proteinTypeList;
};

export default useGetProteinTypeList;
